export default {
    namespaced: true,
    state: {
        settings: null
    },
    getters: {
        settings: (state) => {
            return state.settings;
        }
    },
    actions: {

    },
    mutations: {
        settings (state, settings) {
            state.settings = settings;
        }
    }
}